<template>
  <div>
    <!-- HERO -->
    <section class="hero">
      <div class="container hero__inner">
        <p class="eyebrow reveal">Depuis 2001 · ressuscité en 2026</p>
        <h1 class="hero__title reveal" style="animation-delay: .05s">
          Le site qui vous<br>
          <span class="hero__word">colle&nbsp;la&nbsp;banane<span class="hero__peel">🍌</span></span>
        </h1>
        <p class="hero__lead reveal" style="animation-delay: .12s">
          Le répertoire culte de blagues que <strong>vous</strong> proposez, que
          <strong>vous</strong> notez. La vraie, la dure, celle qui dure.
        </p>
        <div class="hero__cta reveal" style="animation-delay: .18s">
          <BananaButton to="/aleatoire" size="lg" variant="dark">🎲 Une blague au hasard</BananaButton>
          <BananaButton to="/proposer" size="lg" variant="outline">✍️ Proposer la mienne</BananaButton>
        </div>

        <div class="hero__stats reveal" style="animation-delay: .24s">
          <div class="stat"><b>{{ totalLabel }}</b><span>blagues sauvées</span></div>
          <div class="stat"><b>{{ newLabel }}</b><span>nouvelles blagues</span></div>
          <div class="stat"><b>∞</b><span>fous rires</span></div>
        </div>
      </div>
      <div class="hero__wave" aria-hidden="true"></div>
    </section>

    <!-- FEED -->
    <section class="container feed">
      <div class="feed__head">
        <h2>Les blagues</h2>
        <p>Trie-les comme tu veux. Vote pour faire monter tes préférées.</p>
      </div>
      <JokesList show-tabs initial-order="RECENT" :page-size="10" />
    </section>
  </div>
</template>

<script>
import JokesList from '@/components/JokesList.vue'
import BananaButton from '@/components/ui/BananaButton.vue'
import { CATEGORIES_QUERY } from '@/graphql/jokes'

export default {
  name: 'PageHome',
  components: { JokesList, BananaButton },
  data() {
    return { total: null, newCount: null }
  },
  computed: {
    totalLabel() {
      return this.total != null ? new Intl.NumberFormat('fr-FR').format(this.total) : '2 440'
    },
    newLabel() {
      return this.newCount != null ? new Intl.NumberFormat('fr-FR').format(this.newCount) : '0'
    },
  },
  apollo: {
    total: {
      query: CATEGORIES_QUERY,
      update: (data) => data.total,
    },
    newCount: {
      query: CATEGORIES_QUERY,
      update: (data) => data.newJokesCount,
    },
  },
}
</script>

<style scoped>
.hero {
  position: relative;
  text-align: center;
  padding: 60px 0 90px;
  overflow: hidden;
}
.hero__title {
  font-size: clamp(2.6rem, 7vw, 5rem);
  margin: 10px 0 18px;
  color: var(--choco);
}
.hero__word { position: relative; display: inline-block; color: var(--banana-700); }
.hero__peel {
  display: inline-block;
  margin-left: 8px;
  transition: transform 0.4s var(--ease-bounce);
}
.hero__title:hover .hero__peel { transform: rotate(-20deg) scale(1.15); }
.hero__lead {
  font-size: clamp(1.05rem, 2.4vw, 1.35rem);
  max-width: 620px;
  margin: 0 auto 30px;
  color: var(--ink-700);
}
.hero__lead strong { color: var(--ink-900); }
.hero__cta { display: flex; gap: 14px; justify-content: center; flex-wrap: wrap; margin-bottom: 44px; }

.hero__stats { display: inline-flex; gap: 40px; flex-wrap: wrap; justify-content: center; }
.stat { display: flex; flex-direction: column; align-items: center; }
.stat b {
  font-family: var(--font-display);
  font-size: 2.2rem;
  font-weight: 800;
  color: var(--ink-900);
  line-height: 1;
}
.stat span { font-size: 0.82rem; text-transform: uppercase; letter-spacing: 0.08em; color: var(--text-soft); font-weight: 600; margin-top: 4px; }

.hero__wave {
  position: absolute;
  left: 0; right: 0; bottom: -1px;
  height: 60px;
  background: var(--surface);
  border-top: var(--border-w) solid var(--border-c);
  border-radius: 50% 50% 0 0 / 100% 100% 0 0;
  transform: scaleX(1.5);
}

.feed { padding-top: 20px; }
.feed__head { text-align: center; margin-bottom: 30px; }
.feed__head h2 { font-size: clamp(1.8rem, 4vw, 2.6rem); }
.feed__head p { color: var(--text-soft); margin: 0; }

@media (max-width: 560px) {
  .hero { padding: 40px 0 70px; }
  .hero__cta { gap: 10px; margin-bottom: 34px; }
  .hero__stats { gap: 22px; }
  .stat b { font-size: 1.8rem; }
  .stat span { font-size: 0.72rem; }
}
@media (max-width: 380px) {
  /* shrink the display title a touch so the non-breaking "colle la banane"
     never forces horizontal overflow on the smallest phones */
  .hero__title { font-size: clamp(2rem, 9vw, 2.6rem); }
}
</style>
